import { AccountReport, AccountReportList } from '@shared/types/osi/accountReports';

export enum ViewMode {
  Assign_list,
  Editing
}

export interface ReportDialog {
  isOpen: boolean;
  viewMode: ViewMode;
  selectedReport: AccountReport | null;
  selectedAccount: AccountReportList | null;
  editorFilters: FilterModel;
  hookForm: any;
  isReadonly: boolean;
}

export interface FilterModel {
  checked: boolean;
  filterModel: {
    items: any[];
  };
}

export interface Account {
  id: number;
  bankName?: string;
  accountTypeNameRu?: string;
  accountTypeNameKz?: string;
  osiId: number;
  type: AccountType;
  bic: string;
  account: string;
}

export type AccountType = 'SAVINGS' | 'CURRENT';
